import { render, staticRenderFns } from "./PrideBlocks.vue?vue&type=template&id=ab079d32&"
import script from "./PrideBlocks.vue?vue&type=script&lang=js&"
export * from "./PrideBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports